import React from 'react';
import { Layers, CheckCircle2 } from 'lucide-react';

const WhyTraainStaffing = () => {
  const capabilities = [
    'Prepare candidates before day one',
    'Deliver client-specific readiness programs',
    'Standardize quality across placements',
    'Reduce early churn',
    'Increase client confidence and retention',
    'Differentiate beyond "just recruiting"'
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            The Traain Platform
            <br />
            <span className="text-cyan-400">Built for Staffing Firms</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto mb-8">
            Traain centralizes training, role-play practice, and performance readiness into one unified system so staffing teams can:
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4 mb-12">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
            >
              <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-1" />
              <p className="text-lg text-gray-300">{capability}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-block p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-2xl font-bold text-white mb-2">
              Traain isn't content.
            </p>
            <p className="text-xl text-cyan-400">
              It's the engine that turns candidates into client-ready professionals.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyTraainStaffing;